export default __webpack_public_path__ + "static/media/Banner1.2d360b75.png";